module.exports = __webpack_public_path__ + "static/ccf25ada-6d2a-4133-95dc-deb039e22999-8dc88fff30c5454caec676ee22a0f8ec.woff";